import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IDeepLinkProperties } from '../../../navigation/deep-link-properties.interface';
import { NavigationBuilder } from '../../../navigation/navigation.builder';
import { Notification } from '../../../notification-data/notification.model';
import { IRouter } from '../../../shared/interfaces/router.interface';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

/**
 * Legacy notification item component
 *
 * @deprecated since IA NAV changes, will be deleted once we complete the experiment
 */
@Component({
  selector: 'app-notifications-list-item-old',
  templateUrl: './notifications-list-item-old.component.html',
  styleUrls: ['./notifications-list-item-old.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsListItemOldComponent implements OnInit {
  @Input() notification: Notification;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  onClickItem: EventEmitter<Notification> = new EventEmitter<Notification>();
  @Output()
  onDismissItem: EventEmitter<Notification> = new EventEmitter<Notification>();

  private _trackingObject: ITrackingObject;

  feedType: string;
  header: string;
  description: string;
  routeInfo: IRouter;

  constructor(
    private _navigationBuilder: NavigationBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingDispatcher: TrackingDispatcher
  ) {}

  ngOnInit() {
    const deepLinkProperties: IDeepLinkProperties = this._navigationBuilder.buildDeepLinkProperties(
      this.notification.actionUrl
    );

    this.feedType = ['notification-list-item', this.notification.state].join(
      ' '
    );
    this.header = this.notification.mainText;
    this.description = this.notification.auxText;
    this.routeInfo = this._navigationBuilder.buildRouteFromDeepLinkProperties(
      deepLinkProperties
    );

    this._trackingObject = this._trackingObjectBuilder.buildNotification(
      this.notification.state,
      this.notification.actionUrl
    );
  }

  onClick() {
    this._trackingDispatcher.trackEvent(
      this._trackingObject,
      this._trackingActionBuilder.buildTapped(this.trackingScreenName)
    );

    this.onClickItem.emit(this.notification);
  }

  onDismissClick() {
    this._trackingDispatcher.trackEvent(
      this._trackingObject,
      this._trackingActionBuilder.buildDeleted(this.trackingScreenName)
    );

    this.onDismissItem.emit(this.notification);
  }
}
